module.exports = __webpack_public_path__ + "static/media/ITC-OfficinaSansITCPro-Book.906b82c1.svg";